import React from 'react';

const generateModal = ({ title }) => ({
  title,
  body: (
    <div>
      <p>
        The travel time is the time in hours and minutes that it took the initial tsunami wave to travel from the source to the location of effects.
      </p>
    </div>
  ),
});

export const RuWaveTravelHourModal = generateModal({ title: 'Initial Wave Travel Time - Hours' });
export const RuWaveTravelMinuteModal = generateModal({ title: 'Initial Wave Travel Time - Minutes' });
